import { render, staticRenderFns } from "./HistoryBrief.vue?vue&type=template&id=cdd85ac2&scoped=true&"
import script from "./HistoryBrief.vue?vue&type=script&lang=js&"
export * from "./HistoryBrief.vue?vue&type=script&lang=js&"
import style0 from "./HistoryBrief.vue?vue&type=style&index=0&id=cdd85ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd85ac2",
  null
  
)

export default component.exports